// Builds an alertBanner ({ variant, message }) from a failed fetch response
// or a thrown network error. Accepts an optional fallback message for context.
export function errorBannerFromResponse(responseOrError, fallbackMessage) {
    const defaultDetail =
        fallbackMessage ||
        'We are experiencing technical issues. Please try again later.';

    if (responseOrError instanceof Error) {
        return {
            variant: 'error',
            message:
                'Network error. Please check your connection and try again.',
        };
    }

    const problem = responseOrError?.problem;
    const detail = problem?.detail || defaultDetail;
    const traceId = problem?.traceId;

    return {
        variant: 'error',
        message: traceId ? `${detail} (Ref: ${traceId})` : detail,
    };
}
